module.exports = __webpack_public_path__ + "img/home-oval-down.67631cfd.png";